import { AutogenModelExcisetaxHistory, AutogenRowExcisetaxHistory } from "./autogen/AutogenModelExcisetaxHistory";

export class ModelExcisetaxHistory extends AutogenModelExcisetaxHistory<RowExcisetaxHistory> {
	constructor() {
		super(RowExcisetaxHistory);
	}
}

export class RowExcisetaxHistory extends AutogenRowExcisetaxHistory {
}